export default function(str) {
    return str.toUpperCase().replaceAll('_', ' ')
}

